import React, { useState } from "react";
import { TableCell, TableRow, Typography, useTheme } from "@mui/material";
import ToggleIcon from "../../Components/ToggleIcon";
import { useSocketClient } from "../../contexts/SocketClientProvider";
import { IDevice } from "./types";
import ToggleIconLink from "../../Components/ToggleIconLink";
import useDeleteData from "../../hooks/useDeleteData";
import useDialog from "../../contexts/DialogProvider";
import { useTranslation } from "react-i18next";

interface IDeviceProps {
  device: IDevice;
}

const DeviceListItem = (props: IDeviceProps) => {
  const { device } = props;
  const [hasUpdate, setHasUpdate] = useState<boolean>(
    (device.data.new_fw as boolean) || false
  );
  const socketClient = useSocketClient();
  const { t } = useTranslation();
  const deleteHandler = useDeleteData(
    t("Device DEVICE", { device }),
    `/devices/${device.id}`
  );
  const { palette } = useTheme();
  const showDialog = useDialog();

  const triggerUpdate = () => {
    showDialog({
      title: `Update device "${device.name}"`,
      text: `Do you really want to update device "${device.name}"?`,
      buttons: [
        {
          label: "Yes",
          clickCallback: async () => {
            const newValue = !hasUpdate;
            setHasUpdate(newValue);
            socketClient.process_command({
              type: "device",
              id: device.id,
              command: "update_fw",
            });
          },
        },
        { label: "No" },
      ],
    });
  };

  return (
    <TableRow data-cy={`device-${device.id}`}>
      <TableCell data-cy="device-name">
        <Typography>{device.name}</Typography>
      </TableCell>
      <TableCell align="center">
        {hasUpdate && (
          <ToggleIcon
            name={"play-circle-outline"}
            onClick={() => triggerUpdate()}
            color={palette.primary.main}
          />
        )}
      </TableCell>
      <TableCell align="center">
        <ToggleIcon
          name={"delete"}
          onClick={deleteHandler}
          color={palette.primary.main}
          data-cy="device-delete"
        />
      </TableCell>
      <TableCell align="center">
        <ToggleIconLink
          to={`/devices/${device.id}`}
          name={"pencil"}
          color={palette.primary.main}
          data-cy="device-edit"
        />
      </TableCell>
    </TableRow>
  );
};

export default DeviceListItem;
